module.exports = __webpack_public_path__ + "static/img/index_img_1.a05f449.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index_img_1.png
// module id = VMUn
// module chunks = 0